/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-17 10:33:37
 * @LastEditTime: 2019-08-23 11:19:36
 * @LastEditors: Please set LastEditors
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import ElementUI from 'element-ui'
import './assets/css/index.less'
import './assets/css/reset.scss'
import './theme/index.css'
import './assets/css/main.scss'
Vue.use(ElementUI)
import 'font-awesome/css/font-awesome.css'
import echarts from 'echarts';
import bsase from '@/until/base.js'  //一些 默认参数
Vue.prototype.$echarts = echarts;
import china from 'echarts/map/json/china.json'
echarts.registerMap('china', china)
Vue.config.productionTip = false;
import VueCookie from 'vue-cookie'
Vue.use(VueCookie)
import  VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import apis from '@/until/http'
Vue.use(VueQuillEditor)
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;
import {post,fetch,patch,put,del} from './until/http'
//定义全局变量
Vue.prototype.$post=post;
Vue.prototype.$get=fetch;
Vue.prototype.$patch=patch;
Vue.prototype.$put=put;
Vue.prototype.$delete=del;
Vue.prototype.$base=bsase
import Moment from 'moment';
Vue.prototype.moment=Moment;
import globleVar from './until/variable'
Vue.prototype.global = globleVar.baseURL;
Vue.prototype.apis=apis;
router.beforeEach((to, from, next) => {
    if(to.query.customer_id){
        console.log(to.query.customer_id)
        sessionStorage.setItem('customer_id',to.query.customer_id)
    }
    if (!to.meta.requireAuth) {  // 判断该路由是否需要登录权限
        fetch('login','/profile').then((res)=>{
            sessionStorage.setItem('customer_id',res.data.brand_id)
            next();
        }).catch(()=>{
            next();
            // next({
            //     path: '/login',
            //     query: {customer_id: sessionStorage.getItem('customer_id')}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
            // })
        })
    }
    else {
        next();
    }
})
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
